<!--
  ~ Copyright 2022-2023 Aion Technology LLC
  ~
  ~ Licensed under the Apache License, Version 2.0 (the "License");
  ~ you may not use this file except in compliance with the License.
  ~ You may obtain a copy of the License at
  ~
  ~     http://www.apache.org/licenses/LICENSE-2.0
  ~
  ~ Unless required by applicable law or agreed to in writing, software
  ~ distributed under the License is distributed on an "AS IS" BASIS,
  ~ WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  ~ See the License for the specific language governing permissions and
  ~ limitations under the License.
  -->

<div class="schoolSelectionContainer" *ngIf="userLoginService.isSystemAdmin">
  <mat-form-field appearance="outline">
    <mat-select placeholder="Select a school" [(value)]="schoolInstanceCache.item" [compareWith]="compareSchools">
      <mat-option *ngFor="let school of schoolCollectionCache.items" [value]="school">
        {{ school.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
